function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.01 10.495c-1.11-1.11-1.11-2.91 0-4.02 1.11-1.11 2.91-1.11 4.019 0l2.01 2.01-4.02 4.02-2.01-2.01zM10.495 2.01C9.385.9 7.585.9 6.475 2.01L4.467 4.02l4.02 4.019 2.009-2.01c1.11-1.11 1.11-2.91 0-4.02zM6.476 14.96c1.11 1.11 2.909 1.11 4.019 0l2.01-2.009-4.02-4.02-2.01 2.01c-1.11 1.11-1.11 2.91 0 4.02zM14.96 6.476c1.11 1.11 1.11 2.909 0 4.019-1.109 1.11-2.909 1.11-4.019 0l-2.01-2.01 4.02-4.02 2.01 2.01z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.526,
  cy: 8.526,
  r: 2.079,
  stroke: "#F0EFF5"
});

function SvgFrame11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "#20ace8",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11);
export default __webpack_public_path__ + "static/media/Frame 11.2942b13b.svg";
export { ForwardRef as ReactComponent };